import { SITE_VARIABLES } from '../../../common/styles/variables';
import { flexRowCenterCenter } from '../../../common/styles/flex';

interface StylesObject {
  discoveryContainerStyle: { [key: string]: any };
}

const discoveryContainer = {
  ...flexRowCenterCenter,
  width: '100%',
  height: '100%',
  webkitTapHighlightColor: SITE_VARIABLES.COLORS.TRANSPARENT,
  webkitTouchCallout: 'none',
  webkitUserSelect: 'none',
  tapHighlightColor: SITE_VARIABLES.COLORS.TRANSPARENT,
};

export const getDiscoveryContainerStyleObject = (): StylesObject => ({
  discoveryContainerStyle: {
    ...discoveryContainer,
  },
});
